<div class="container">
    <div class="row justify-content-center mt-5">
      <div class="col-lg-4 col-md-6 col-sm-6 mt-5">
        <div class="card shadow">
          <div class="card-title text-center border-bottom">
            <h2 class="p-3">Forgot Password?</h2>
          </div>
          <div class="card-body" [ngClass]="{'cspinner load1': this.showLoader}">
            <form class="info_form p-0 m-0" (ngSubmit)="forgotPassword()" [formGroup]="forgotPasswordForm" #forgotPasswordNgForm="ngForm">
            
              <div class="mb-3">
                <label for="email" class="form-label">Email</label>
                <input type="text" class="form-control" id="email" placeholder="Enter email" formControlName="email" />
                <ng-container *ngIf="forgotPasswordForm.controls['email'].dirty || forgotPasswordForm.controls['email'].touched || forgotPasswordNgForm.submitted">
                    <div class="text-danger" *ngIf="forgotPasswordForm?.get('email')?.hasError('required')">
                        This field is required
                    </div>
                    <div class="text-danger" *ngIf="forgotPasswordForm?.get('email')?.hasError('email') || forgotPasswordForm?.get('email')?.hasError('pattern')">
                        Please enter valid email
                    </div>
                </ng-container>
              </div>

              <div class="mb-3 text-right">
                <a routerLink="/login">Login</a>
              </div>

              <div class="mb-3">
                <button type="submit" class="btn btn-theme btn-block">Submit</button>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  </div>